import React, { Component } from "react";

export default class ThirdSection extends Component {
  render() {
    return (
      <section class="third-hightlight-wrapper">
        <div class="container">
          <div class="title-wraper bold">iPhone 11 Pro</div>

          <div class="description-wrapper">
            Pro cameras. Pro display. Pro performance.
          </div>

          <div class="price-wrapper">
            From $24.95/mo. or $599 with trade‑in.
          </div>

          <div class="links-wrapper">
            <ul>
              <li>
                <a href="">Learn more</a>
              </li>
              <li>
                <a href="">Buy</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}
